import {createReducer, on} from '@ngrx/store';
import * as FiltersConfigActions from './filters-config.actions';

export const filtersConfigFeatureKey = 'filtersConfig';

export interface FiltersConfig {
  segmentMainTypes: string[],
  segmentSubTypes: string[],
  segmentAudienceTypes: string[],
  brands: string[],
  categories: string[]
}

export const initialState: FiltersConfig = {
  brands: [],
  categories: [],
  segmentAudienceTypes: [],
  segmentMainTypes: [],
  segmentSubTypes: []
};

export const filtersConfigReducer = createReducer(
  initialState,
  on(FiltersConfigActions.segmentMainTypesLoaded, (state, action) => ({...state, segmentMainTypes: action.data})),
  on(FiltersConfigActions.segmentSubTypesLoaded, (state, action) => ({...state, segmentSubTypes: action.data})),
  on(FiltersConfigActions.segmentAudienceTypesLoaded, (state, action) => ({
    ...state,
    segmentAudienceTypes: action.data
  })),
  on(FiltersConfigActions.brandsLoaded, (state, action) => ({...state, brands: action.data})),
  on(FiltersConfigActions.categoriesLoaded, (state, action) => ({...state, categories: action.data})),
);
